export const indexCopy = {
  // The index page copy lives at index2.ts
  index_releases: "Quarterly Releases",
  index_releases_pt1: "Our next release is ",
  index_releases_pt2: ", which is planned for ",
  index_releases_released: "Released",
  index_releases_beta: "Beta",
  index_releases_rc: "RC"
}